import React, {useContext} from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from '@material-ui/core/'
import {FaRegFile, FaSearch, FaPrint, FaTrash} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import {Mutation} from 'react-apollo'
import {deleteDataRecord} from '../../graphql/barcode/mutations/deleteRecordMutation'
import {libraryPageQuery} from '../../graphql/barcode/queries/libraryPageQuery'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryPopupMoreButtons.styles'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

export default function BarcodeLibraryPopupMoreButtons(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const {setBarcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {setBarcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const toast = useContext(ToastMessageContext)
  const currentUser = React.useContext(UserContext)

  setBarcodeSheetRecord(props.record.sheet)
  setBarcodeLabelRecord(props.record.label)
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const [deleting, setDeleting] = React.useState(false)
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const userId = parseInt(window.localStorage.getItem('user_id'))

  function handleClose() {
    setDeleteDialog(false)
  }

  function showDeleteDialog(event) {
    setDeleteDialog(true)
  }

  function deleteDataClick(event, deleteData) {
    if (!validateBarcodePermission(currentUser, 'can_delete')) {
      return
    }
    const {showTable, record} = props
    deleteData({
      variables: {
        id: record.id,
        table: showTable,
      },
    })
    setDeleting(true)
  }

  function mutationLoad() {
    setDeleteDialog(false)
    props.poppOverClose(null)
    setDeleting(false)
    toast.popMessage(t('barcode.library.popup-more-buttons.successful-delete'), 'success')
  }

  return (
    <div className={classes.buttonContainer}>
      <Box margin="auto">
        {validateBarcodePermission(currentUser, 'can_generate') && (
          <Button
            color="primary"
            size="small"
            className={classes.buttonStyle}
            component={Link}
            to={{
              pathname:
                props.showTable === 'fieldValue'
                  ? '/barcode-wizard-generate-field-value'
                  : 'barcode-libray-generate-automatic',
              state: {
                barcodeData: props.record,
                previous: false,
                generatePage: true,
                barcodeDataId: props.record.id,
              },
            }}
          >
            <FaRegFile />{' '}
            <Box marginLeft={1}>{t('barcode.library.popup-more-buttons.generate')}</Box>
          </Button>
        )}
      </Box>

      <Box margin="auto">
        <Button
          color="primary"
          size="small"
          className={classes.buttonStyle}
          component={Link}
          to={{
            pathname: 'barcode-library-preview',
            state: {
              barcodeData: props.record,
              previous: false,
              previewFieldValue: props.showTable === 'fieldValue',
            },
          }}
        >
          <FaSearch /> <Box marginLeft={1}>{t('barcode.library.popup-more-buttons.preview')}</Box>
        </Button>
      </Box>

      <Box margin="auto" hidden={props.showTable === 'fieldValue'}>
        {validateBarcodePermission(currentUser, 'can_generate') && (
          <Button
            disabled={props.record.lastPrinted === '-'}
            color="primary"
            size="small"
            className={classes.buttonStyle}
            component={Link}
            to={{
              pathname: 'barcode-libray-reprint',
              state: {
                barcodeData: props.record,
                previous: false,
                generatePage: false,
              },
            }}
          >
            <FaPrint /> <Box marginLeft={1}>{t('barcode.library.popup-more-buttons.reprint')}</Box>
          </Button>
        )}
      </Box>

      <Box margin="auto">
        {validateBarcodePermission(currentUser, 'can_delete') && (
          <Button
            color="secondary"
            size="small"
            className={classes.buttonStyle}
            onClick={e => showDeleteDialog(e)}
          >
            <FaTrash /> <Box marginLeft={1}>{t('barcode.library.popup-more-buttons.delete')}</Box>
          </Button>
        )}
        {deleteDialog && (
          <div class="ds-modal-wrapper">
            <div class="ds-backdrop"></div>
            <div class="ds-modal-simple ds-modal--destructive">
              <div class="ds-modal-header">
                <h4 class="mdl-title ds-t400r ds-tg700" style={{textAlign: 'left'}}>
                  {t('barcode.library.popup-more-buttons.delete-details')}
                </h4>
              </div>
              <div class="ds-modal-body ds-tg600 ds-t100r" style={{textAlign: 'left'}}>
                {t('barcode.library.popup-more-buttons.delete-description')}
              </div>
              <div class="ds-modal-footer">
                <Mutation
                  mutation={deleteDataRecord}
                  refetchQueries={() => [
                    {
                      query: libraryPageQuery,
                      variables: {
                        accountId: parseInt(props.accountId),
                        token: accessToken,
                        userId: userId,
                        filter: '',
                      },
                    },
                  ]}
                  awaitRefetchQueries
                  onCompleted={() => mutationLoad()}
                >
                  {(deleteDataRecord, {loading, error, data}) => (
                    <button
                      class="mdl-affirmative ds-btn-destructive mr-8"
                      onClick={e => deleteDataClick(e, deleteDataRecord)}
                      autoFocus
                    >
                      {deleting ? (
                        <div>
                          {t('barcode.library.popup-more-buttons.deleting')}
                          <CircularProgress size={20} />
                        </div>
                      ) : (
                        t('barcode.library.popup-more-buttons.yes-delete')
                      )}
                    </button>
                  )}
                </Mutation>

                <button
                  class="mdl-negative ds-btn-secondary"
                  onClick={handleClose}
                  color="primary"
                  disabled={deleting}
                  className={classes.stringTextTransform}
                >
                  {t('barcode.library.popup-more-buttons.nevermind')}
                </button>
              </div>
            </div>
          </div>
        )}
      </Box>
    </div>
  )
}
